export default __webpack_public_path__ + "static/media/roadmap-circle-pit.be4ff4be.png";